import React from "react";
import { Button, Collapse } from "antd";
// 引用图片修改
import Loading from "../../../assets/img/diagnostic/loading.png";
import ErrorPic from "../../../assets/img/diagnostic/error.png";
import Success from "../../../assets/img/diagnostic/success.png";

const { Panel } = Collapse;

class DiaResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errList: [],
    };
  }

  componentWillMount() {
    this.collectError(this.props);
  }

  componentWillReceiveProps(nextProps) {
    // 每次数据源变更都需要收集错误数据
    this.collectError(nextProps);
  }

  // 收集检测报错信息
  collectError = (props) => {
    const results = [];
    const source = props.dataSource;
    for (let i = 0; i < props.dataSource.length; i++) {
      source[i].children.map((v) => {
        if (v.status === "error") {
          results.push(v);
        }
        return null;
      });
    }

    this.setState({
      errList: results,
    });
  };

  // 获取子项检测状态图片
  getStatusImg = (item) => {
    switch (item.status) {
      case "waiting":
      case "uncheck":
        return item.icon;
      case "loading":
        return Loading;
      case "error":
        return ErrorPic;
      case "success":
        return Success;
      default:
        return item.icon;
    }
  };

  jumpTargetPage = (record) => {
    record.btnHandler(this.props.selectTarget, this.props.onAdd);
  };

  formatterMsg = (msg) => {
    if (!msg) {
      return "";
    }
    const arrList = msg.split(",");

    return arrList.map((v) => <div>{v}</div>);
  };

  render() {
    const { errList } = this.state;
    const { dataSource } = this.props;
    const defaultKeys = dataSource.map((v, index) => index);

    return (
      <div style={{ padding: "24px" }}>
        <Collapse
          className="dia-result-box"
          expandIconPosition="right"
          defaultActiveKey={[...defaultKeys, "error"]}>
          {errList.length > 0 && (
            <Panel
              key="error"
              className="module-item err-module-item"
              header={
                <div className="module-info">
                  <span className="module-name">本次检测出以下问题</span>
                </div>
              }>
              <div className="children-box">
                {errList.map((child) => (
                  <div className="child-item">
                    <div className="left">
                      <span>
                        <img src={this.getStatusImg(child)} alt="" />
                        <span className="child-name">{child.name}</span>
                      </span>
                      <span className={`child-msg ${child.status === "error" && "child-err-msg"}`}>
                        {this.formatterMsg(child.msg)}
                      </span>
                    </div>
                    {child.status === "error" && child.btnHandler && (
                      <Button type="primary" onClick={() => this.jumpTargetPage(child)}>
                        查看
                      </Button>
                    )}
                  </div>
                ))}
              </div>
            </Panel>
          )}
          {dataSource.map((v, index) => (
            <Panel
              key={index}
              className={`module-item ${index === dataSource.length - 1 && "last-module-item"}`}
              header={
                <div className="module-info">
                  <img src={v.icon} alt="" />
                  <span className="module-name">{v.name}</span>
                  <span className="total">(共{v.children.length}项)</span>
                </div>
              }>
              <div className="dia-progress">
                已检测<span className="complete-cnt"> {v.completeCnt} </span>
                项，检测到<span className="err-cnt"> {v.errorCnt} </span>
                项有问题
              </div>
              <div className="children-box">
                {v.children.map((child) => (
                  <div className="child-item">
                    <div className="left">
                      <span>
                        <img src={this.getStatusImg(child)} alt="" />
                        <span className="child-name">{child.name}</span>
                      </span>
                      <span className={`child-msg ${child.status === "error" && "child-err-msg"}`}>
                        {this.formatterMsg(child.msg)}
                      </span>
                    </div>
                    {child.status === "error" && child.btnHandler && (
                      <Button type="primary" onClick={() => this.jumpTargetPage(child)}>
                        查看
                      </Button>
                    )}
                  </div>
                ))}
              </div>
            </Panel>
          ))}
        </Collapse>
      </div>
    );
  }
}

export default DiaResult;



// WEBPACK FOOTER //
// ./src/AntD/pages/diagnosticManage/diagnosticAnalysis/diaResult.js